<template>
  <b-card
    :title="header"
    body-class="mx-3 mx-md-5 mx-lg-5 mx-xl-5 px-3 px-md-5 px-lg-5 px-xl-5"
    class="mt-5 p-0 p-md-5 p-lg-5 p-xl-5 w-75"
    style="/**width: 550px**/"
  >
    <b-form onkeydown="return event.key != 'Enter'">
      <p class="pb-2 grey--text">{{ subheader }}</p>

      <b-form-group
        id="input-group-password"
        label="Password"
        label-for="input-password"
        v-if="currentStep === 1"
      >
        <b-form-input
          id="input-password"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter password"
          :state="state.password"
          aria-describedby="input-password-feedback"
          @keyup.enter="nextStep"
        ></b-form-input>

        <b-form-invalid-feedback id="input-password-feedback">
          <!-- eslint-disable-next-line -->
          {{ errors.password }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="input-group-new-password"
        label="New Password"
        label-for="input-new-password"
        v-else
      >
        <b-form-input
          id="input-new-password"
          v-model="form.new_password"
          type="password"
          required
          placeholder="Enter new password"
          :state="state.new_password"
          aria-describedby="input-new-password-feedback"
          @keyup.enter="nextStep"
        ></b-form-input>

        <b-form-invalid-feedback id="input-new-password-feedback">
          <!-- eslint-disable-next-line -->
          {{ errors.new_password }}
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- <hr class="modal-divider mt-5" /> -->

      <div class="justify-content-between">
        <!-- <div class="mt-3">Forgot Password?</div> -->
        <b-container fluid>
          <b-row cols="2" class="verify-actions">
            <b-col cols="6" class="text-center text-lg-right text-xl-right">
              <b-button
                class="w-75 mr-0 mr-lg-2 mr-xl-2 btn-outlined bg-white text-dark"
                variant="outline-secondary"
                :to="{ name: 'user.settings-page', hash: '#account' }"
              >
                Cancel
              </b-button>
            </b-col>
            <b-col cols="6" class="text-center text-lg-left text-xl-left">
              <b-button
                variant="primary"
                class="w-75 ml-0 ml-lg-2 ml-xl-2"
                :disabled="loading"
                @click="nextStep"
              >
                <b-spinner v-if="loading" small label="Loading" />&nbsp;Continue
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <!-- <div class="w-100 mt-2 mb-1">
          <b-button
            class="w-25 mr-2 btn-outlined bg-white text-dark"
            variant="outline-secondary"
            :to="{ name: 'user.settings-page', hash: '#account' }"
            >Cancel</b-button
          >
          <b-button
            variant="primary"
            class="w-25 ml-2 float-right"
            :disabled="loading"
            @click="nextStep"
          >
            <b-spinner v-if="loading" small label="Loading" />&nbsp;Continue
          </b-button>
        </div> -->
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      verificationToken: (state) => state.auth.verificationToken,
    }),
  },

  data() {
    return {
      loading: false,
      header: 'Verify Password',
      subheader: 'Enter your current password to change your password',
      currentStep: 1,
      form: {
        password: null,
        new_password: null,
      },
      state: {
        password: null,
        new_password: null,
      },
      errors: {
        password: null,
        new_password: null,
      },
    }
  },

  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      changePassword: 'auth/changePassword',
    }),

    nextStep() {
      if (this.currentStep === 1) {
        this.generateToken()
      }
      if (this.currentStep === 2) {
        this.updatePassword()
      }
    },

    async generateToken() {
      this.loading = true
      await this.getVerificationToken({
        password: this.form.password,
      })
        .then(() => {
          this.currentStep++
          this.header = 'New Password'
          this.subheader = 'Enter new password'
        })
        .catch((error) => {
          if (error.response.data) {
            this.state.password = false
            this.errors.password = error.response.data.message
          }
        })
      this.loading = false
    },

    async updatePassword() {
      this.loading = true
      await this.changePassword({
        old_password: this.form.password,
        new_password: this.form.new_password,
        new_password_confirmation: this.form.new_password,
      })
        .then(() => {
          this.$router.push({
            name: 'user.settings-page',
            hash: '#account',
          })
        })
        .catch((error) => {
          if (error.response.data) {
            this.state.new_password = false
            this.errors.new_password = error.response.data.message
          }
        })
      this.loading = false
    },
  },

  watch: {
    'form.password'() {
      this.state.password = this.form.password.length !== 0 ? null : false
      this.errors.password = 'This field is required'
    },

    'form.new_password'() {
      this.state.new_password =
        this.form.new_password.length !== 0 ? null : false
      this.errors.new_password = 'This field is required'
    },
  },
}
</script>

<style lang="scss" scoped>
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}

/* Large screens: the buttons sit as a natural-size pair on the left, aligned
   with the rest of the content. Each column keeps the old button footprint
   (75% of a half-width column = 37.5% of the row). */
@media (min-width: 992px) {
  .verify-actions {
    justify-content: flex-start;
  }

  .verify-actions > [class*='col'] {
    flex: 0 0 auto;
    width: 37.5%;
    max-width: none;
  }

  .verify-actions .btn {
    width: 100% !important;
  }
}

/* Small screens (< lg): centre the heading + description, let the card use the
   full width, trim its heavy body padding, and show the buttons side-by-side
   filling their half-columns with a clear gap, down to 320px. */
@media (max-width: 991.98px) {
  .card.w-75 {
    width: 100% !important;
    margin-top: 2rem !important;
  }

  .card /deep/ .card-body {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 1.25rem !important;
  }

  .card /deep/ .card-title,
  .card .grey--text {
    text-align: center;
  }

  .verify-actions .btn {
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .verify-actions > [class*='col']:first-child {
    padding-right: 0.5rem !important;
  }

  .verify-actions > [class*='col']:last-child {
    padding-left: 0.5rem !important;
  }
}
</style>
